import { EventEmitter, Injectable, Output } from '@angular/core';
import { FooterItem } from '../components/navigation/footer-base/footer-base.component';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FooterService {

  private footerItemsSubject: BehaviorSubject<FooterItem[]> = new BehaviorSubject<FooterItem[]>([]);

  public get footerItems(): Observable<FooterItem[]> {
    return this.footerItemsSubject.asObservable();
  }

  public setFooterItems(footerItems: FooterItem[]): void {
    this.footerItemsSubject.next(footerItems);
  }
}
